import React from "react";
import Grid from "../common/Grid";
import ContactTile from "../common/ContactSlider/ContactTile";
import Headline from "../common/Headline";
import DefaultContent from "../common/Content";
import styled from "styled-components";
import { FirstLevelAccordion } from "../common/Accordion";
import { spacing } from "../theme";
import StyledSpan from "../common/StyledSpan";

const StyledHeadline = styled(Headline)`
  margin: 0;
`;

const Content = styled(DefaultContent)`
  ${spacing("margin-top", 40)}
`;

const Accordion = styled(FirstLevelAccordion)`
  & .accordion__item > [aria-hidden="false"] {
    border-top: none;
  }
`;
interface Props {
  label?: string;
  headline: string;
  contacts: {
    name: string;
    role: string;
    phone: string;
    email: string;
    type: string;
  }[];
  uuid: string;
}

export default function AccordionSection(props: Props) {
  const LabelComponent = (
    <>
      {props.label && <StyledSpan tiny>{props.label}</StyledSpan>}
      <StyledHeadline size={4} level={2}>
        {props.headline}
      </StyledHeadline>
    </>
  );

  return (
    <Accordion label={LabelComponent} ariaLevel={1} uuid={props.uuid}>
      <Content smallBottomMargin smallTopMargin>
        <Grid mobileColumns={1} tabletColumns={2} columns={3}>
          {props.contacts.map(({ ...c }, idx) => (
            <ContactTile key={c.name + idx} {...c} />
          ))}
        </Grid>
      </Content>
    </Accordion>
  );
}
